import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { X, User, LogOut } from 'lucide-react';

export default function VacateModal({ isOpen, onClose, tenant, onConfirm, loading }) {
  const [vacateDate, setVacateDate] = useState('');
  const [deductions, setDeductions] = useState('');

  useEffect(() => {
    if (isOpen) {
      setVacateDate(new Date().toISOString().split('T')[0]);
      setDeductions('0');
    }
  }, [isOpen]);

  if (!isOpen || !tenant) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(vacateDate, parseFloat(deductions) || 0);
  };

  return (
    <>
      <div className="fixed inset-0 bg-slate-900/50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow-2xl max-w-md w-full" data-testid="vacate-modal">
          <div className="flex items-center justify-between p-6 border-b border-slate-200">
            <h2 className="text-xl font-bold text-slate-900 font-heading">Vacate Tenant</h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
              data-testid="close-vacate-modal"
            >
              <X className="w-5 h-5 text-slate-500" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-6">
            <div className="flex items-center gap-3 p-4 bg-red-50 rounded-lg border border-red-200">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <User className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <p className="text-sm text-red-700 mb-1">Tenant Details</p>
                <p className="font-bold text-red-900">{tenant.name}</p>
                <p className="text-sm text-red-800">Deposit: ₹{tenant.depositAmount?.toLocaleString('en-IN') || 0}</p>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <Label className="text-sm font-semibold text-slate-700 mb-1.5 block">Vacate Date *</Label>
                <Input
                  type="date"
                  required
                  value={vacateDate}
                  onChange={(e) => setVacateDate(e.target.value)}
                  className="h-12"
                />
              </div>

              <div>
                <Label className="text-sm font-semibold text-slate-700 mb-1.5 block">Deductions from Deposit (₹)</Label>
                <Input
                  type="number"
                  min="0"
                  step="0.01"
                  value={deductions}
                  onChange={(e) => setDeductions(e.target.value)}
                  className="h-12"
                  placeholder="Enter deductions if any"
                />
              </div>
            </div>

            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-sm text-yellow-900">
                <span className="font-semibold">Warning:</span> Vacating a tenant will unassign them from the bed, making it available for a new assignment.
              </p>
            </div>

            <div className="flex gap-3">
              <Button
                type="button"
                onClick={onClose}
                variant="outline"
                className="flex-1 h-12 rounded-xl"
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="flex-1 h-12 rounded-xl bg-red-600 hover:bg-red-700 text-white font-semibold flex items-center justify-center gap-2"
                disabled={loading}
              >
                <LogOut className="w-5 h-5" />
                {loading ? 'Processing...' : 'Vacate Tenant'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
